//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VALIDATE_INFO } from "../../store/mutation-types";
import { mapGetters } from "vuex";
export default {
  name: "ValidateDownloadPage",
  computed: {
    ...mapGetters({
      form: VALIDATE_INFO,
    }),
    title() {
      if (this.$route.query.msg) {
        return "";
      }
      if (this.$route.query.type === "approve") {
        return "Approved";
      } else {
        return "Declined";
      }
    },
    msg() {
      if (this.$route.query.msg) {
        return this.$route.query.msg;
      }
      if (this.$route.query.type === "approve") {
        return `This schedule will auto post on @${this.form.user.social_username}\nGet Apphi for free - World‘s best social media planner.`;
      } else {
        return `This schedule will not auto post on @${this.form.user.social_username}\nGet Apphi for free - World‘s best social media planner.`;
      }
    },
  },
  methods: {
    iosClick() {
      window.open(
        "https://itunes.apple.com/us/app/apphi-scheduler-for-instagram/id1251406049?mt=8",
        "_blank"
      );
      this.value = false;
    },
    androidClick() {
      window.open("https://go.onelink.me/app/apphiwebforandroid", "_blank");
      this.value = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/validate/Download.vue